import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

const state = () => ({
  racingEvent: {},
  eventOdds: [],
});

const actions = {
  async fetchRacingCalendarEvent(state, { eventId, bookmaker }, fetcher = dataFetch) {
    const racingEventEndpoint = `${API_END_POINTS.RACING_CALENDAR_EVENT}&eventId=${eventId}`;
    const res = await fetcher(racingEventEndpoint);
    state.commit('SET_RACING_EVENT', res);

    try {
      const filteredOdds = await fetchEventOdds(eventId, bookmaker.bookmakerName);
      state.commit('SET_EVENT_ODDS', filteredOdds);
    } catch (error) {
      console.error(error);
    }
  },
};

async function fetchEventOdds(eventId, bookmakerId, fetcher = dataFetch) {
  const paramString = 'betTypes=fixed-win&type=bookmaker';
  const eventOddsEndpoint = `${API_END_POINTS.ODDS.EVENT_BASE}${eventId}/?${paramString}`;
  const res = await fetcher(eventOddsEndpoint);
  const filteredOdds = filterOddsByBookmaker(res.odds, bookmakerId);
  return filteredOdds;
}

function filterOddsByBookmaker(odds, bookmakerId) {
  return odds.filter(item => item.bookmakerId === bookmakerId);
}

const mutations = {
  SET_EVENT_ODDS: (state, data) => {
    state.eventOdds = data;
  },
  SET_RACING_EVENT: (state, data) => {
    state.racingEvent = data;
  },
};

const getters = {
  getEventOdds: state => {
    return state.eventOdds;
  },
  getEventInfo: state => {
    return state.racingEvent.event;
  },
  getEventAnalysis: state => {
    return state.racingEvent.tips ? state.racingEvent.tips.analysis : '';
  },
  getEventSelections: state => {
    return state.racingEvent.tips ? state.racingEvent.tips.selections : [];
  },
  getEventBookmaker: state => {
    return state.racingEvent.bookmaker || {};
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
